import axios from "axios";
import { oktaAuth } from "../oktaConfig";

const authClient = axios.create();

authClient.interceptors.request.use(
  async (config) => {
    try {
      const accessToken = await oktaAuth.getOrRenewAccessToken();
      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      } else {
        window.localStorage.clear();
      }
      return config;
    } catch (err) {
      window.localStorage.clear();
      return Promise.reject(err);
    }
  },
  (error) => Promise.reject(error),
);
export default authClient;
